import { useEffect, useMemo, useState } from "react";
import { fetchPricing } from "@/services/api";
import { priceOrder } from "@/lib/pricingEngine";

// Shipping zones, free-delivery thresholds and bulk discounts, loaded once and
// applied to a cart. The figures here are a preview only — /api/checkout prices
// the order again server-side, so a stale or failed load cannot change what the
// customer is actually charged.
//
// If the rules cannot be fetched the engine falls back to each product's own
// shipping cost, which is how the store priced orders before zones existed.

export function usePricing(items, country) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    fetchPricing()
      .then((s) => { if (live) setSettings(s); })
      .catch(() => {})
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  // The cart stores a product's own id as `id`; the engine matches rules on
  // `productId`.
  const lines = useMemo(
    () =>
      (items || []).map((i) => ({
        productId: i.id,
        title: i.title,
        price: Number(i.price) || 0,
        qty: Number(i.qty) || 0,
        shippingCost: Number(i.shippingCost) || 0,
      })),
    [items],
  );

  const quote = useMemo(
    () => priceOrder(lines, settings || {}, country),
    [lines, settings, country],
  );

  return { settings, quote, loading };
}
